import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import moment from 'moment';

import { LOG_MISSING_TRANSLATIONS, LOCALE_URL } from '../config';

const activeLanguage = window.localStorage.getItem('lang') || 'de';

moment.locale(activeLanguage);

i18n.use(XHR).init({
  backend: {
    addPath: `${LOCALE_URL}/add/{{ns}}?lang={{lng}}`,
    loadPath: `${LOCALE_URL}/{{ns}}?lang={{lng}}`,
    crossDomain: true,
  },
  lng: activeLanguage,
  fallbackLng: 'en',

  // save missing keys
  saveMissing: true,
  // saveMissingTo: 'current',
  updateMissing: true,

  // have a translations namespace used around the full app
  ns: ['translations'],
  defaultNS: 'translations',
  keySeparator: false, // we use content as keys

  interpolation: {
    formatSeparator: ',',
  },

  // react options
  react: {
    wait: true,
    bindStore: LOG_MISSING_TRANSLATIONS ? 'added removed' : false,
  },

  // debug: true,
});
export default i18n;



// WEBPACK FOOTER //
// ./src/translations/i18n.js